import React from 'react';
import PolicyImpactTool from '../tools/PolicyImpactTool';
import { useLocation } from '../../contexts/LocationContext';
import { PageHeader } from '../layout/PageHeader';
import { useUserRole } from '../../contexts/UserRoleContext';

export const PolicyTool: React.FC = () => {
  const { selectedLocation, selectedGeofips, coreDataLoading } = useLocation();
  const { hasAnyRole, loading } = useUserRole();

  if (loading) {
    return (
      <div className="page-container">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  if (!hasAnyRole(['developer', 'super_admin'])) {
    return (
      <div className="page-container">
        <div className="access-denied">
          <h1>Access Denied</h1>
          <p>You do not have permission to access the Policy Tool. This feature is only available to developers and administrators.</p>
        </div>
      </div>
    );
  }

  if (coreDataLoading) {
    return (
      <div>
        <PageHeader
          title="GHG Policy Impact Tool (Under development)"
          variant="maps"
        />
        <div className="page-container">
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p>Loading core data for {selectedLocation}...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <PageHeader
        title="GHG Policy Impact Tool (Under development)"
        variant="maps" // reuse the purple header styling
      />

      <div className="page-container">
        <PolicyImpactTool location={selectedLocation} geofips={selectedGeofips} />
      </div>
    </div>
  );
};
